import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/MaterialEstudio.css';

const MARINEROS_PDF = {
  file: 'data/marineros.pdf',
  type: 'dropbox',
  dropboxUrl: 'https://www.dropbox.com/scl/fi/fvqall0022ibsi78jtfxs/CONOCIMIENTOS-MARINEROS-BARBUDO.pdf?rlkey=2x48igy6k0aitl5s9badlq3dp&st=ubqshd6x&raw=1',
};

const ESPECIFICOS_TOPICS = [
  {
    key: 'sintesis',
    label: 'Síntesis de Cultura Naval',
    file: 'data/sintesis2025.pdf',
    type: 'dropbox',
    dropboxUrl: 'https://www.dropbox.com/scl/fi/mqmqaa120v647f5f3jd1d/1.-SINTESIS_CULT_NAV_2026OK.pdf?rlkey=ltwhah8pbkf8ef1yp942rv425&st=4jxsky03&raw=1',
  },
];

const LEGISLACION_TOPICS = [
  {
    key: 'legnav1',
    label: 'Mro a 2do. Mtre.',
    file: 'data/legNav1.pdf',
    type: 'dropbox',
    dropboxUrl: 'https://www.dropbox.com/scl/fi/mt3uusvm2m8mpc1umjbes/2.-COMP_LEG.-NAV._CLASMAR_PFAM-2026OK.pdf?rlkey=uatqysyqmtfkneq7h59qcoy6y&st=89vlnft7&raw=1',
  },
  {
    key: 'legnav2',
    label: '1er. Mtre. a Cap. de Corb.',
    file: 'data/legNav2.pdf',
    type: 'dropbox',
    dropboxUrl: 'https://www.dropbox.com/scl/fi/mjhyn5r82regsatsx0gvz/1.-COMP_LEG.-NAV._CAPS-Y-OFLS_PFAM-2026.pdf?rlkey=jslv2m1sxi7d7woxrdeze4kds&st=nhnowsre&raw=1',
  },
];

const MaterialEstudio = () => {
  const [showEspecificos, setShowEspecificos] = useState(false);
  const [showLegislacion, setShowLegislacion] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const navigate = useNavigate();

  const downloadFile = (url, filename, docId) => {
    // Verificar si el documento ya fue descargado en esta sesión de navegador
    const downloadedDocs = JSON.parse(localStorage.getItem('vortex_downloaded_docs') || '[]');

    if (downloadedDocs.includes(docId)) {
      console.log(`Documento ${docId} ya descargado anteriormente. Saltando descarga automática.`);
      return;
    }

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Registrar en el historial de descargas
    downloadedDocs.push(docId);
    localStorage.setItem('vortex_downloaded_docs', JSON.stringify(downloadedDocs));
  };

  const handleAreaClick = (area) => {
    if (area === 'especificos') {
      setShowEspecificos(true);
      setShowLegislacion(false);
      setSelectedTopic(null);
    } else if (area === 'legislacion') {
      setShowLegislacion(true);
      setShowEspecificos(false);
      setSelectedTopic(null);
    } else if (area === 'marineros') {
      // Dual action: Open viewer and smart download
      downloadFile(MARINEROS_PDF.dropboxUrl, 'Conocimientos_Marineros.pdf', 'marineros_vortex_doc');
      navigate(`/dashboard/doc-viewer?url=${encodeURIComponent(MARINEROS_PDF.dropboxUrl)}&title=${encodeURIComponent('Conocimientos Marineros')}`);
    } else {
      setShowEspecificos(false);
      setShowLegislacion(false);
      setSelectedTopic(null);
    }
  };

  const handleTopicClick = (topic) => {
    if (topic.type === 'route') {
      navigate(topic.route || '/');
    } else if (topic.type === 'dropbox' && topic.dropboxUrl) {
      // Dual action: Open viewer and smart download
      const docId = `doc_${topic.key}`;
      downloadFile(topic.dropboxUrl, `${topic.label.replace(/\s+/g, '_')}.pdf`, docId);
      navigate(`/dashboard/doc-viewer?url=${encodeURIComponent(topic.dropboxUrl)}&title=${encodeURIComponent(topic.label)}`);
    } else {
      setSelectedTopic(topic.key);
    }
  };

  return (
    <div className="material-estudio-container">
      <h2>Material de Estudio</h2>
      <div className="material-grid">
        <div className="material-card" role="button" tabIndex={0} onClick={() => handleAreaClick('marineros')} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleAreaClick('marineros'); } }}>
          <div className="material-icon">⚓</div>
          <div className="material-content">
            <h3>Conocimientos Marineros</h3>
            <p>Material sobre navegación, estructura de buques y procedimientos marítimos</p>
          </div>
        </div>
        <div className="material-card" onClick={() => handleAreaClick('legislacion')}>
          <div className="material-icon">📜</div>
          <div className="material-content">
            <h3>Legislación Naval</h3>
            <p>Leyes, reglamentos y normativas navales vigentes</p>
          </div>
        </div>
        <div className="material-card" onClick={() => handleAreaClick('especificos')}>
          <div className="material-icon">🎯</div>
          <div className="material-content">
            <h3>Conocimientos Específicos</h3>
            <p>Material técnico y especializado para el personal naval</p>
          </div>
        </div>
      </div>
      {showEspecificos && !selectedTopic && (
        <div className="especificos-topics">
          <h3>Selecciona un tema:</h3>
          <div className="material-grid">
            {ESPECIFICOS_TOPICS.map(topic => (
              <div key={topic.key} className="material-card" onClick={() => handleTopicClick(topic)}>
                <div className="material-content">
                  <h4>{topic.label}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {showLegislacion && !selectedTopic && (
        <div className="legislacion-topics">
          <h3>Selecciona tu jerarquía:</h3>
          <div className="material-grid">
            {LEGISLACION_TOPICS.map(topic => (
              <div key={topic.key} className="material-card" onClick={() => handleTopicClick(topic)}>
                <div className="material-content">
                  <h4>{topic.label}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MaterialEstudio; 